import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            redirect: '/'
        },
        {
            path: '/',
            name: 'PageView',
            component: resolve => require(['@/view/PageView'], resolve),
            children: [
                // 首页
                {
                    path: '/',
                    name: 'home',
                    component: resolve => require(['@/view/HomePage'], resolve),
                    meta: {
                        title: '朗格注塑机 | 温州友创机械有限公司'
                    }
                },

                // 注塑机
                {
                    path: '/service',
                    name: 'service',
                    component: resolve => require(['@/view/Service'], resolve),
                },

                // 辅机设备
                {
                    path: '/equipment',
                    name: 'equipment',
                    redirect: '/equipment/manipulator',
                    component: resolve => require(['@/view/equipment'], resolve),
                    children: [
                        {
                            path: '/equipment/manipulator',
                            name: 'equipment',
                            component: resolve => require(['@/view/equipment_manipulator'], resolve),
                        },
                        {
                            path: '/equipment/grinder',
                            name: 'equipment',
                            component: resolve => require(['@/view/equipment_grinder'], resolve),
                        },
                        {
                            path: '/equipment/suctionMachine',
                            name: 'equipment',
                            component: resolve => require(['@/view/equipment_suctionMachine'], resolve),
                        },
                        {
                            path: '/equipment/coolingMachine',
                            name: 'equipment',
                            component: resolve => require(['@/view/equipment_coolingMachine'], resolve),
                        },
                        {
                            path: '/equipment/mixingMachine',
                            name: 'equipment',
                            component: resolve => require(['@/view/equipment_mixingMachine'], resolve),
                        }
                    ]
                },

                // 发展历程
                {
                    path: '/developmentHistory',
                    name: 'developmentHistory',
                    component: resolve => require(['@/view/developmentHistory'], resolve),
                },

                // 公司简介
                {
                    path: '/CompanyIntroduction',
                    name: 'CompanyIntroduction',
                    component: resolve => require(['@/view/CompanyIntroduction'], resolve),
                },

                // 注塑机
                {
                    path: '/sae',
                    name: 'sae',
                    component: resolve => require(['@/view/sae'], resolve),
                },
                {
                    path: '/s9',
                    name: 's9',
                    component: resolve => require(['@/view/s9'], resolve),
                },
                {
                    path: '/le',
                    name: 'le',
                    component: resolve => require(['@/view/le'], resolve),
                },
                {
                    path: '/anteng',
                    name: 'anteng',
                    component: resolve => require(['@/view/anteng'], resolve),
                },

                //联系我们
                {
                    path: '/contactus',
                    name: 'contactus',
                    component: resolve => require(['@/view/ContactUs'], resolve),
                },


            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js